function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./tabs.scss";
import template from "./tabs.html";

export var TabsComponent = {
  template: template,
  transclude: true,
  bindings: {
    tabsItems: '<items',
    _currentIndex: '<current' },

  controller: /*#__PURE__*/function () {TabsComponentController.$inject = ["LayoutService", "$scope", "$timeout"];
    function TabsComponentController(LayoutService, $scope, $timeout) {
      "ngInject";_classCallCheck(this, TabsComponentController);

      this.LayoutService = LayoutService;
      this.$scope = $scope;
      this.$timeout = $timeout;
      console.log(this);

      var RIGHT = true;
      var LEFT = false;

      this.tabsItems = [];
      this.currentIndex = 0;
      this._currentIndex = 0;
      this.direction = LEFT;

      this.getDirection = function (prev, next, total) {
        if (next === 0 && prev >= total - 1) {
          return RIGHT;
        } else if (next === total - 1 && prev <= 0) {
          return LEFT;
        } else return next > prev;
      };
    }_createClass(TabsComponentController, [{ key: "$onInit", value: function $onInit()

      {
        // this.$scope.$watch('$ctrl._currentIndex',(next,prev, $scope) => {
        //   if (next > this.tabsItems.length -1 ) next = 0;
        //   if (next < 0) next = this.tabsItems.length-1;
        //
        //   this.direction = this.getDirection(prev,next,this.tabsItems.length);
        //   this._currentIndex = next;
        //
        //   this.$timeout(()=>this.currentIndex = next);
        // });
      } }, { key: "$onChanges", value: function $onChanges(_ref)

      {var tabsItems = _ref.tabsItems,_currentIndex = _ref._currentIndex;
        console.warn('$onChanges', tabsItems, _currentIndex);
        // if (tabsItems && tabsItems.currentValue) {
        //   this.tabsItems = angular.copy(tabsItems.currentValue);
        // }
        // if (_currentIndex && typeof _currentIndex.currentValue === 'undefined') {
        //   this._currentIndex = 0;
        // }
      } }, { key: "$postLink", value: function $postLink()

      {
      } }, { key: "$onDestroy", value: function $onDestroy()

      {} }, { key: "setCurrent", value: function setCurrent()

      {var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this._currentIndex = parseInt(index) || 0;
      } }, { key: "next", value: function next()

      {
        this.setCurrent(this.currentIndex + 1);
      } }, { key: "prev", value: function prev()

      {
        this.setCurrent(this.currentIndex - 1);
      } }]);return TabsComponentController;}() };